import { escapeHtml } from "@emkit/builder-core";
export const STATS_DEFAULTS = {
    items: [
        { id: "s1", value: "10k", label: "Active users", suffix: "+" },
        { id: "s2", value: "99.99", label: "Uptime", suffix: "%" },
        { id: "s3", value: "50", label: "Countries", suffix: "+" },
        { id: "s4", value: "4.9", label: "Average rating", prefix: "★ " },
    ],
    columns: 4,
    size: "md",
    align: "center",
    valueColor: "#111827",
    labelColor: "#6b7280",
    background: "transparent",
    divided: false,
};
const SIZES = {
    sm: { value: 28, label: 13, paddingY: 16 },
    md: { value: 40, label: 15, paddingY: 24 },
    lg: { value: 56, label: 17, paddingY: 32 },
};
const ALIGN_MAP = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
};
export const statsWidget = {
    type: "stats",
    defaultProps: STATS_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-stats" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty stats — add items in the inspector)</div>`;
        }
        const cols = props.columns ?? Math.min(items.length, 4);
        const size = SIZES[props.size ?? "md"];
        const align = props.align ?? "center";
        const valueColor = props.valueColor ?? "#111827";
        const labelColor = props.labelColor ?? "#6b7280";
        const bg = props.background ?? "transparent";
        const divided = props.divided ?? false;
        const textAlign = align === "center" ? "center" : align;
        const itemsAlign = ALIGN_MAP[align];
        const gridStyle = [
            "display:grid",
            `grid-template-columns:repeat(${cols},minmax(0,1fr))`,
            "gap:0",
            "max-width:1200px",
            "margin:0 auto",
            "font-family:inherit",
        ].join(";");
        const cells = items
            .map((it, i) => {
            const borderLeft = divided && i > 0 && i % cols !== 0
                ? "border-left:1px solid rgba(0,0,0,0.08);"
                : "";
            const cellStyle = [
                "display:flex",
                "flex-direction:column",
                `align-items:${itemsAlign}`,
                `text-align:${textAlign}`,
                `padding:${size.paddingY}px 16px`,
                borderLeft,
            ].join(";");
            const prefix = it.prefix ? escapeHtml(it.prefix) : "";
            const suffix = it.suffix ? escapeHtml(it.suffix) : "";
            return `<div class="emk-stat" style="${cellStyle}"><div style="font-size:${size.value}px;font-weight:700;line-height:1;letter-spacing:-0.02em;color:${valueColor}">${prefix}${escapeHtml(it.value)}${suffix}</div><div style="margin-top:8px;font-size:${size.label}px;color:${labelColor};line-height:1.4">${escapeHtml(it.label)}</div></div>`;
        })
            .join("");
        return `<div class="emk-stats" style="background:${bg};padding:20px 0"><div style="${gridStyle}">${cells}</div></div>`;
    },
};
//# sourceMappingURL=stats.js.map